import { TableHead, TableRow } from '@mui/material';
import { bool, func, shape, string } from 'prop-types';
import React, { Component } from 'react';
import TitleCells from './TitleCells';

class EnhancedTableHead extends Component {
  render() {
    const { order, onSort, showName } = this.props;

    return (
      <TableHead
        sx={theme => ({
          width: '100%',
          borderTop: `1px solid ${theme.palette.divider}`,
        })}
      >
        <TableRow sx={{ height: 48 }}>
          <TitleCells showName={showName} order={order} onSort={onSort} />
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  order: shape({ by: string, isReverse: bool }).isRequired,
  onSort: func.isRequired,
  showName: bool.isRequired,
};

export default EnhancedTableHead;
